import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import INFOCITY_PORTALS from "../config/infocity-network";

/* ── Ecosystem portal card — extracted verbatim from HomePage.jsx so it now
   renders globally (App.js, right before Footer) on every public page,
   instead of only on Home. Behavior unchanged: only the active portal
   (Jobs) is a real clickable link; the rest are inert "Próximamente" cards
   (no invented URLs/navigation for verticals that aren't launched yet). ── */
function PortalCard({ portal, youAreHere, comingSoon }) {
  const [imgError, setImgError] = useState(false);
  const w = portal.logoContentWidth;
  const MAX_CONTENT_WIDTH = 955; // InfoCityTravel — the widest logo, used as scale reference
  const widthPct = 72 * (w / MAX_CONTENT_WIDTH);
  const fullImgWidthPct = (1200 / w) * 100;
  const leftOffsetPct = -(26 / w) * 100;
  const Tag = portal.active ? "a" : "div";
  const tagProps = portal.active
    ? { href: portal.url, target: "_self" }
    : { "aria-hidden": true, role: "presentation" };
  return (
    <Tag {...tagProps}
      data-testid={`ecosystem-portal-${portal.key}`}
      className={`group flex flex-col items-center rounded-2xl bg-white border-2 transition-all duration-200 overflow-hidden
        ${portal.active ? "border-[#028CF8] shadow-md cursor-pointer" : "border-[#E5E7EB] cursor-default"}`}>
      <div className="w-full flex-shrink-0 flex items-center justify-center" style={{ minHeight: "62px", padding: "12px 0 6px" }}>
        {!imgError ? (
          <div style={{ width: `${widthPct}%`, aspectRatio: `${w} / 218`, position: "relative", overflow: "hidden" }}>
            <img src={portal.logo} alt={portal.name} onError={() => setImgError(true)}
              style={{
                position: "absolute", top: "-22.94%", left: `${leftOffsetPct}%`,
                width: `${fullImgWidthPct}%`, height: "146.79%", maxWidth: "none", display: "block",
              }} />
          </div>
        ) : (
          <div style={{ width: "72%", aspectRatio: "3.9 / 1", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: portal.color + "12", borderRadius: "8px" }}>
            <div style={{ width: 26, height: 26, borderRadius: 8, backgroundColor: portal.color + "20", border: `2px solid ${portal.color}40`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Poppins", fontWeight: 800, color: portal.color, fontSize: "12px" }}>
              {(portal.shortName || portal.name.replace("InfoCity", ""))[0]}
            </div>
          </div>
        )}
      </div>
      <div style={{ padding: "8px 0", display: "flex", justifyContent: "center", width: "100%" }}>
        {portal.active ? (
          <span style={{ backgroundColor: "#028CF8", color: "white", fontSize: "11px", fontWeight: 700, fontFamily: "Poppins", padding: "3px 12px", borderRadius: "999px" }}>
            {youAreHere}
          </span>
        ) : (
          <span data-testid={`ecosystem-coming-soon-${portal.key}`} style={{ color: "#94A3B8", fontSize: "11px", fontWeight: 500, fontFamily: "Poppins" }}>
            {comingSoon}
          </span>
        )}
      </div>
    </Tag>
  );
}

/* Cierre institucional antes del Footer, en todas las páginas web públicas
   (montado en App.js). Reutiliza el mismo namespace de traducciones que ya
   usaba HomePage (`sections.ecosystemTitle`, `cta.youAreHere/comingSoon`). */
export default function EcosystemSection() {
  const { t } = useLanguage();
  return (
    <section className="py-6 bg-[#F8FAFC] border-t border-[#E5E7EB]" data-testid="ecosystem-section">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <p className="text-center text-xs font-semibold text-[#94A3B8] font-poppins uppercase tracking-wide mb-4">
          {t("sections.ecosystemTitle")}
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3" data-testid="ecosystem-portals-grid">
          {INFOCITY_PORTALS.map((portal) => (
            <PortalCard key={portal.key} portal={portal} youAreHere={t("cta.youAreHere")} comingSoon={t("cta.comingSoon")} />
          ))}
        </div>
      </div>
    </section>
  );
}
